const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://4gmri80hb8.execute-api.eu-central-1.amazonaws.com/prod';
const API_BASE_URL_SETUP = process.env.REACT_APP_API_BASE_URL || 'https://emea-vic.acer.com/fe';

export const apiConfig = {
  baseURL: API_BASE_URL_SETUP,
  marketplaceResolve: API_BASE_URL_SETUP + '/marketplace/resolve',
  marketplaceLink: API_BASE_URL_SETUP + '/marketplace/link',
  marketplaceSubscribe: API_BASE_URL_SETUP + '/marketplace/subscribe',
  marketplaceSession: API_BASE_URL_SETUP + '/marketplace/session',
};

export const adminEndpoints = {
    users: API_BASE_URL + '/api/admin/users',
    apiKeys: API_BASE_URL + '/api/admin/api-keys',
    usagePlans: API_BASE_URL + '/api/admin/usage-plans',
    settings: API_BASE_URL + '/api/admin/settings',
    detachRequests: API_BASE_URL + '/api/admin/detach-requests',
};

export const userEndpoints = {
    apiKey: API_BASE_URL + '/api/user/api-key',
    usagePlan: API_BASE_URL + '/api/user/usage-plan',
    usage: API_BASE_URL + '/api/user/usage',
    availablePlans: API_BASE_URL + '/api/usage-plans',
};